import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1032 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1032 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user\"><path d=\"M494.87 507.636c160.94 0 291.405-111.604 291.405-249.237 0-137.665-130.465-249.23-291.405-249.23-160.924 0-291.412 111.565-291.396 249.23 0 137.633 130.472 249.237 291.404 249.237zm133.585 83.102H385.591c-207.889 0-376.434 144.123-376.434 321.91v20.78c0 72.666 168.545 72.736 376.434 72.736h242.864c207.865 0 376.403-2.683 376.403-72.736v-20.771c0-177.796-168.522-321.919-376.403-321.919z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol